
import { Route, Routes, Navigate } from "react-router-dom";
import DashboardLayout from "../Components/DashboardLayout/DashboardLayout";
import menuConfig from "../../config/MenuConfig";

const AdminRouters = () => {

  return (
    <DashboardLayout>
      <Routes>
        {menuConfig.filter(item => item.category === "Admin").map(({ path, component: Component }) => (
          <Route
            key={path}
            path={path.replace("/admin/", "")} // React Router expects relative path
            element={<Component />}
          />
        ))}

        {/* Fallback route if no match */}
        <Route path="*" element={<Navigate to="/admin" />} />
      </Routes>
    </DashboardLayout>
  );
};

export default AdminRouters;
